<div class="video-player">
    <video class="video-js" controls disablePictureInPicture preload="auto" #videoEl></video>
</div>
